module.exports = "/_next/static/images/cel-614671221b0f68af1b5d0cabab00e301.svg";